import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-BiKz7_SZ.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const UturnLeftOutlinedSize24Component = (props, ref) => (jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("path", { d: "M8.00013 0.999756L1 7.99989L8.00004 14.9999L9.27283 13.7271L4.44572 8.90002H15.0498C18.4464 8.90002 21.1998 11.6535 21.1998 15.05C21.1998 18.4466 18.4464 21.2 15.0498 21.2H6.99984V23H15.0498C19.4405 23 22.9998 19.4407 22.9998 15.05C22.9998 10.6594 19.4405 7.10002 15.0498 7.10002H4.44545L9.27292 2.27255L8.00013 0.999756Z", fill: "var(--magritte-ui-icon-color)" }) }) }));
const UturnLeftOutlinedSize24 = hoc(forwardRef(UturnLeftOutlinedSize24Component), 'UturnLeftOutlinedSize24');

export { UturnLeftOutlinedSize24 as default };
//# sourceMappingURL=UturnLeftOutlinedSize24.js.map
